<template>
  <header class="navbar-wrapper">
    <nav class="navbar navbar-expand-md navbar-light">
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbar-content" aria-controls="navbar-content" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <router-link :to="'/'" class="navbar-brand text-hide" exact>Vendoscope</router-link>

      <div class="collapse navbar-collapse" id="navbar-content">
        <ul class="navbar-nav mr-auto">
          <template v-for="section in navElements">
            <router-link
              class="nav-item"
              tag="li"
              :to="section.route"
              v-if="!section.dropdown && $root.checkPermission(section.permission)"
            >
              <a class="nav-link">{{section.label}}</a>
            </router-link>
            <li
              class="nav-item dropdown"
              v-else-if="section.dropdown && section.dropdown.some((item) => $root.checkPermission(item.permission))"
            >
              <router-link class="nav-link dropdown-toggle" :to="section.route" event="" data-toggle="dropdown">
                {{section.label}}
              </router-link>
              <div class="dropdown-menu">
                <router-link
                  v-for="subsection in section.dropdown"
                  v-if="!subsection.hasOwnProperty('permission') || $root.checkPermission(subsection.permission)"
                  :key="subsection.route"
                  class="dropdown-item"
                  :to="`${section.route}${subsection.route}`"
                  v-text="subsection.label"
                />
              </div>
            </li>
          </template>
        </ul>

        <template v-if="$root.user">
          <ul class="navbar-nav navbar-user">
            <router-link v-if="$root.isDev" class="nav-item" tag="li" to="/dev"><a class="nav-link">Dev</a></router-link>
            <li class="nav-item dropdown">
              <a href="#" class="nav-link dropdown-toggle" data-toggle="dropdown">
                <avatar
                  class="navbar-avatar-wrapper"
                  :username="`${$root.user.second_name} ${$root.user.first_name}`"
                  :size="30"
                ></avatar>
              </a>
              <div class="dropdown-menu dropdown-menu-right">
                <h6 class="dropdown-header">
                  {{ `${$root.user.second_name} ${$root.user.first_name}` }}
                </h6>
                <div class="dropdown-divider"></div>
                <a href="#" class="dropdown-item" @click.prevent="logout">Выйти</a>
                <div v-if="$root.release" class="small text-muted mt-2" style="padding-left: 1.3rem;">
                  Версия {{ $root.release }}
                </div>
              </div>
            </li>
          </ul>
        </template>
      </div>
    </nav>
  </header>
</template>

<script>
  import Avatar from 'vue-avatar'
  import auth from '../auth'

  export default {
    name: 'Navbar',
    components: {Avatar},
    methods: {
      logout () {
        auth.logout()
      },
    },
    data () {
      return {
        navElements: [
          { route: '/admin',
            label: 'Админка',
            permission: 'web_admin_ffd12',
            dropdown: [
              {route: '/ffd12', label: 'ККТ ФФД 1.2', permission: 'web_admin_ffd12'},
              {route: '/lists', label: 'Списки', permission: 'web_admin_ffd12'},
            ]},
          { route: '/machines', label: 'Автоматы', permission: 'web_ta' },
          { route: '/reports',
            label: 'Отчеты',
            dropdown: [
              {route: '/sales', label: 'Продажи', permission: 'web_sales'},
              {route: '/expenditure', label: 'Расход продуктов', permission: 'web_rate'},
              {route: '/encashment', label: 'Инкассации', permission: 'web_collect'},
              {route: '/events', label: 'События', permission: 'web_events'},
              {route: '/downtime', label: 'Простои', permission: 'web_downtime'},
              {route: '/notifications', label: 'Уведомления', permission: 'web_alerts'},
              {route: '/receipts', label: 'Чеки', permission: 'web_bills'},
              {route: '/service', label: 'Обслуживание', permission: 'web_service'},
              {route: '/samples', label: 'Мои выборки'},
            ]},
          {route: '/service', label: 'Обслуживание', permission: 'web_service'},
          { route: '/settings',
            label: 'Настройки',
            dropdown: [
              {route: '/recipes', label: 'Рецептуры и продукты', permission: 'web_matrix'},
              {route: '/schedule', label: 'Расписание отчетов', permission: 'web_schedule'},
              {route: '/notifications', label: 'Уведомления', permission: 'web_alert_settings'},
              {route: '/users', label: 'Пользователи', permission: 'web_users'},
              {route: '/categories', label: 'Категории'},
            ]},
          {route: '/orders', label: 'Заявки', permission: 'web_requests'},
          {route: '/modems', label: 'Модемы', permission: 'web_modems'},
          {route: '/receipts', label: 'Чеки', permission: 'web_bills'},
          { route: '/admin',
            label: 'Еще',
            dropdown: [
              {route: '/limits', label: 'Пороговые значения', permission: 'web_thresholds'},
              {route: '/documents', label: 'Документы и чек-листы', permission: 'web_checklist'},
            ]},
        ],
      }
    },
  }
</script>

<style lang="scss">
  @import "boot";
  .page-index .navbar-wrapper {
    position: sticky;
    top: 0;
    z-index: 10;
  }
  .navbar {
    font-size: 1.1em;
    a {
      cursor: pointer;
    }
  }
  .navbar-avatar-wrapper {
    display: inline-flex !important;
    margin-top: -50px;
    margin-bottom: -50px;
    line-height: inherit !important;
    vertical-align: middle;
    font-family: inherit !important;
  }
  .navbar-light {
    background-color: $white;
    border-bottom: 2px solid $gray-300;
    margin-bottom: -1px;
  }
  .navbar-dark.bg-info {
    background-color: $navbar-dark-bg !important;
    @include gradient-x(mix($primary, $navbar-dark-bg, 50%), $navbar-dark-bg);
  }
  .navbar-brand {
    background: url('../../img/vendoscope-logo.png') center no-repeat;
    background-size: contain;
    color: transparent !important;
    width: 10rem;
    height: 2.6rem;
    margin-top: -.15rem;
    .navbar-dark & {
      background-image: url('../../img/vendoscope-logo-white.png');
    }
  }
  .navbar-nav {
    user-select: none;
    font-weight: $font-weight-bold;
    .nav-link {
      position: relative;
      padding-top: .72rem;
      padding-bottom: .9rem;
      text-transform: uppercase;
      letter-spacing: .03em;
      font-size: 92%;
      .navbar-dark & {
        text-shadow: 0 2px 3px rgba($gray-900, .2);
      }
    }
    .nav-link.active,
    .nav-item.active .nav-link {
      &:before {
        content: '';
        position: absolute;
        top: 0;
        bottom: auto;
        left: $navbar-nav-link-padding-x;
        right: $navbar-nav-link-padding-x;
        height: 3px;
        background-color: $navbar-light-active-color;
        .navbar-dark & {
          background-color: rgba($white, .75);
        }
      }
    }
    .navbar-light & > .dropdown > .dropdown-menu {
      border-top: 2px solid $gray-400;
      margin-left: $navbar-nav-link-padding-x;
    }
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/navbar.vue